import CONFIG from '~/config'

export const getCloudflareImageURL = imageId => `https://imagedelivery.net/${CONFIG.CLOUDFLARE_ACCOUNT_HASH}/${imageId}/public`
